import { Expose } from 'class-transformer';

export default class JobCancelError {
    reason: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}